import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { useCreateXenditIntegration } from 'modules/profile/payment-gateways/integrations/xendit/hooks';
import { XenditCreateIntegrationInterface, XenditIntegrationErrorsInterface } from 'modules/profile/payment-gateways/integrations/xendit/types';
import { getXenditHelpPageLink } from 'modules/profile/payment-gateways/integrations/xendit/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: XenditCreateIntegrationInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: ''
};
const defaultErrors: XenditIntegrationErrorsInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: ''
};
const XenditCreateModal = () => {
  const $ = _c(46);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    createXenditIntegration
  } = useCreateXenditIntegration();
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== createXenditIntegration || $[1] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await createXenditIntegration(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = createXenditIntegration;
    $[1] = mutatePaymentIntegrations;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onCreate = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.XenditID)
    });
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("dashboard.settings.payment-gateways.xendit_integration");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== errors || $[14] !== t) {
    t7 = {
      field: "organizationName",
      onRender: (value, onChange) => <FormInput key="xendit-organization-name-create" label={t("dashboard.settings.payment-gateways.organization_name")} value={value} onChange={e_0 => onChange(e_0.target.value)} required={true} error={errors.organizationName} />
    };
    $[13] = errors;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== errors || $[17] !== t) {
    t8 = {
      field: "webhookSecret",
      onRender: (value_0, onChange_0) => <FormInput key="xendit-webhook-secret-create" label={t("dashboard.settings.payment-gateways.webhook_secret")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} required={true} error={errors.webhookSecret} />
    };
    $[16] = errors;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== errors || $[20] !== t) {
    t9 = {
      field: "secretAccessToken",
      onRender: (value_1, onChange_1) => <FormInput key="xendit-secret-access-token-create" label={t("dashboard.settings.payment-gateways.secret_access_token")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} required={true} error={errors.secretAccessToken} />
    };
    $[19] = errors;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== errors || $[23] !== t) {
    t10 = {
      field: "publicAccessToken",
      onRender: (value_2, onChange_2) => <FormInput key="xendit-public-access-token-create" label={t("dashboard.settings.payment-gateways.public_access_token")} value={value_2} onChange={e_3 => onChange_2(e_3.target.value)} required={true} error={errors.publicAccessToken} />
    };
    $[22] = errors;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t11 = [t7, t8, t9, t10];
    $[25] = t10;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = user?.dashboardLocale;
  let t13;
  if ($[30] !== t12) {
    t13 = getXenditHelpPageLink(t12);
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = getPaymentProcessorTitle(PaymentProcessorEnum.XenditPH);
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13) {
    t15 = <HelpCenterLink link={t13} integration={t14} />;
    $[33] = t13;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["organizationName", "webhookSecret", "secretAccessToken", "publicAccessToken"];
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== onCreate || $[37] !== opened || $[38] !== t11 || $[39] !== t15 || $[40] !== t4 || $[41] !== t5) {
    t17 = <CreateModal fullCaption={t4} caption={t5} opened={opened} onClose={t6} defaultValues={defaultValues} needToast={false} creatable={t11} additionalInfo={t15} onCreate={onCreate} requiredFields={t16} />;
    $[36] = onCreate;
    $[37] = opened;
    $[38] = t11;
    $[39] = t15;
    $[40] = t4;
    $[41] = t5;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17 || $[44] !== t3) {
    t18 = <>{t3}{t17}</>;
    $[43] = t17;
    $[44] = t3;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  return t18;
};
export default XenditCreateModal;